import React, { useEffect } from 'react';
import "./App.css";
import { useLocation } from "react-router-dom";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Footer from "./Components/Footer/Footer";
import Navbar from './Components/Navbar/Navbar'
import Products from "./Components/Products/Products";
import Home from "./Components/Home/Home";
import Services from "./Components/Services/Services";
import Career from "./Components/Career/Career";
import Contact from "./Components/Contact/Contact";
import AOS from "aos";
import "aos/dist/aos.css";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return null;
}
function App() {
  useEffect(() => {
    AOS.init({
      duration: 1250, // Increase the duration for slower, smoother animations
      easing: "ease-out", // Smoother easing
      once: false, // Allow animations to trigger again when scrolling back
      offset: 100, // Start animation a bit earlier before reaching the element
    });
  }, []);
  return (
    <>
      <Router>
       <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/aboutus" element={<Home />} />
          <Route path="/" element={<Products />} />
          <Route path="/services" element={<Services />} />
          <Route path="/career" element={<Career />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
